export default __webpack_public_path__ + "static/sprite-dde756cd616c549670c6663436baa5a8.svg";